import * as actionTypes from "../actionTypes/actionTypes";
import { 
    getMarketsService,getRenderCustomerService,getCompanyTypeService,createNewCustomerService,
    updateCustomerService,deleteCustomerService,getSalesOfficeBasedMarketsService,getLicenseByCustomerService,
    getTransactionByCustomerService,getTransactionTypeService,getDiscountsService,generateNewLicenseService,
    createNewLicenseService,updateQuantityService,renewalLicenseService,getContactsByCustomerService,
    createNewContactService,deleteCustomerContactService,updateCustomerContactService
 } from "../services/CustomerServices";
import {getToolsOfferedService} from "../services/ToolsOfferedService";
import {getToolsService} from "../services/ToolsService";
import * as _ from "lodash";
 const getSalesOfficeBasedMarketsList = (salesOfficeId) => {
  return async(dispatch) => {
    dispatch({
      type:actionTypes.GET_C_SALESOFFICE_MARKETS
    })    
    await getSalesOfficeBasedMarketsService(salesOfficeId)
    .then((response) => {
      const data = response.data
      const sortedMarkets = _.sortBy(data, ['marketName']);
      dispatch({
        type:actionTypes.GET_C_SALESOFFICE_MARKETS_SUCCESS,
        payload:sortedMarkets
      })
    })
    .catch((error) =>{
      dispatch({
        type:actionTypes.GET_C_SALESOFFICE_MARKETS_FAILURE,
        payload:error
      })
    })
  }
}

const getSelectedMarketsData = (marketsSelectedData) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.MARKETS_SELECTION,
      payload:marketsSelectedData
    })
  }
}

const getSelectedExpirationDatesData = (expirationsDatesSelectedData) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.EXPIRATION_DATE_SELECTION,
      payload:expirationsDatesSelectedData
    })
  }
}

const getExpirationDatesList = () => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.GET_U_EXPIRATIONDATE
      })
      window.startLoading();      
      try{  
        const data = [
          {
              "key":Math.random(),
              "expiryId":"1",
              "expiryName":"Expired beyond last 3 months",
              "expiryKey":"hasExpiredLicenseBeyondLastThreeMonths",
              "checked": true
          },
          {
              "key":Math.random(),
              "expiryId":"2",         
              "expiryName":"Expired within last 3 months",
              "expiryKey":"hasExpiredLicenseWithinLastThreeMonths",
              "checked":true
          },
          {
              "key":Math.random(),
              "expiryId":"3",         
              "expiryName":"Expires within 1 month",
              "expiryKey":"hasExpiredLicenseInOneMonth",
              "checked": true
          },
          {
              "key":Math.random(),
              "expiryId":"4",         
              "expiryName":"Expires within 3 months",
              "expiryKey":"hasExpiredLicenseInThreeMonths",
              "checked": true
          },
          {
              "key":Math.random(),
              "expiryId":"5",         
              "expiryName":"Expires beyond 3 months",
              "expiryKey":"noExpiredLicenseInThreeMonths",
              "checked": true
          },
            {
                "key":Math.random(),
                "expiryId":"6",
                "expiryName":"Has No License",
                "expiryKey":"hasNoLicense",
                "checked": true
            }
      ]
          dispatch({
              type: actionTypes.GET_U_EXPIRATIONDATE_SUCCESS,
              payload: data
          })
        }catch(error){
          dispatch({
            type: actionTypes.GET_U_EXPIRATIONDATE_FAILURE,
            payload: error
        })      
        }
  }
}

const getStatusList = () => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.GET_C_STATUS
      })
      window.startLoading();      
    try{
  
        const data = [
    {
       "statusId":"1",         
        "statusName":"Active",
        "isActive": true
    },
    {
        "statusId":"2",         
        "statusName":"Cancelled",
        "isActive": false
    }
]
          dispatch({
              type: actionTypes.GET_C_STATUS_SUCCESS,
              payload: data
          })
        }catch(error){
          dispatch({
            type: actionTypes.GET_C_STATUS_FAILURE,
            payload: error
        })      
        }
  }
}

const getSelectedStatusData = (statusSelectedData) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.STATUS_SELECTION,
      payload:statusSelectedData
    })
  }
}

const getCustomersList = (salesOfficeId) => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.GET_C_CUSTOMERS
      })
      window.startLoading();
      getRenderCustomerService(salesOfficeId).then((response)=>{        
        const data = response.data;
        const sortedCustomers = _.sortBy(data, ['companyName']);        
          dispatch({
              type: actionTypes.GET_C_CUSTOMERS_SUCCESS,
              payload: sortedCustomers
          })
      })
      .catch((error)=>{
        dispatch({
          type: actionTypes.GET_C_CUSTOMERS_FAILURE,
          payload: error
      })
      }).finally(()=>{
        window.stopLoading();
      })
    }
}
const getRenderCustomersListData = (customerTableData) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.CUSTOMER_TABLE_DATA_CREATION,
      payload:customerTableData
    })
  }
}


const getCompanyTypeList = () => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.GET_C_COMPANYTYPE
      })
      window.startLoading();
      getCompanyTypeService().then((response)=>{
        const data = response.data;
          dispatch({
              type: actionTypes.GET_C_COMPANYTYPE_SUCCESS,
              payload: data
          })
      })
      .catch((error)=>{
        dispatch({
          type: actionTypes.GET_C_COMPANYTYPE_FAILURE,
          payload: error
      })
      }).finally(()=>{
        window.stopLoading();
      })
  }
}

const createNewCustomer = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.CREATE_NEW_CUSTOMER_START,
    });    
    await createNewCustomerService(requestPayload)
      .then((response) => {        
        const data = response.data;
        dispatch({
          type: actionTypes.CREATE_NEW_CUSTOMER_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_NEW_CUSTOMER_FAILURE,
          payload: error,
        });
      });
  };
};

const updateCustomerAction = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type:actionTypes.UPDATE_CUSTOMER_START
    });
    await updateCustomerService(requestPayload)
    .then((response) => {
      const data = response.data;
      dispatch({
        type:actionTypes.UPDATE_CUSTOMER_SUCCESS,
        payload:data
      });
    })
    .catch((error) => {
      dispatch({
        type:actionTypes.UPDATE_CUSTOMER_FAILURE,
        payload:error
      })
    })
  }
}

const deleteCustomerAction = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.DELETE_CUSTOMERS_START
    });
    await deleteCustomerService(requestPayload)
    .then((response) => {
      const data = response.data;
      dispatch({
        type:actionTypes.DELETE_CUSTOMER_SUCCESS,
        payload:data
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.DELETE_CUSTOMER_FAILURE,
        payload: error
      })
    })
  }
}


const getLicenseByCustomer = (customerId) => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.GET_C_LICENSE
      })       
 
          
await getLicenseByCustomerService(customerId)
    .then((response) => {      
      const data = response.data
      
      dispatch({
        type:actionTypes.GET_C_LICENSE_SUCCESS,
        payload:data
      });
    })
    .catch((error) =>{
      dispatch({
        type:actionTypes.GET_C_LICENSE_FAILURE,
        payload:error
      })
    })
  }
}

const getTools = () => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.GET_TOOLS
      })
      window.startLoading();
      getToolsService().then((response)=>{
        const data = response.data;
          dispatch({
              type: actionTypes.GET_TOOLS_SUCCESS,
              payload: data
          })
      })
      .catch((error)=>{
        dispatch({
          type: actionTypes.GET_TOOLS_FAILURE,
          payload: error
      })
      }).finally(()=>{
        window.stopLoading();
      })
  }
}

const getTransactionTypesList = () => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.GET_TRANSACTION_TYPE
      })
      window.startLoading();
      getTransactionTypeService().then((response)=>{
        const data = response.data;
          dispatch({
              type: actionTypes.GET_TRANSACTION_TYPE_SUCCESS,
              payload: data
          })
      })
      .catch((error)=>{
        dispatch({
          type: actionTypes.GET_TRANSACTION_TYPE_FAILURE,
          payload: error
      })
      }).finally(()=>{
        window.stopLoading();
      })
  }
}

const getContactsByCustomer= (customerId) => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.GET_CUSTOMER_CONTACTS
      })       
          
  await getContactsByCustomerService(customerId)
    .then((response) => {      
      const data = response.data
      
      dispatch({
        type:actionTypes.GET_CUSTOMER_CONTACTS_SUCCESS,
        payload:data
      });
    })
    .catch((error) =>{
      dispatch({
        type:actionTypes.GET_CUSTOMER_CONTACTS_FAILURE,
        payload:error
      })
    })
  }
}

const createNewContactByCustomer = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.CREATE_NEW_CONTACT,
    });    
    await createNewContactService(requestPayload)
      .then((response) => {        
        const data = response.data;
        
        dispatch({
          type: actionTypes.CREATE_NEW_CONTACT_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_NEW_CONTACT_FAILURE,
          payload: error,
        });
      });
  };
};


const getDiscountsList = () => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.GET_DISCOUNTS
      })
      window.startLoading();
      getDiscountsService().then((response)=>{
        var arr1 = [{
                            discountId:"0",
                            discountLabel:"No Discount",
                            discountPercentage: 0,
                            transactionTypeId: ""
                        }];
        const data = arr1.concat(response.data);
        
          dispatch({
              type: actionTypes.GET_DISCOUNTS_SUCCESS,
              payload: data
          })
      })
      .catch((error)=>{
        dispatch({
          type: actionTypes.GET_DISCOUNTS_FAILURE,
          payload: error
      })
      }).finally(()=>{
        window.stopLoading();
      })
  }
}

const getTransactionByCustomer = (customerId) => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.GET_C_TRANSACTION
      })
      
      /*try{  
        const data = [
          {
            "transactionId": 1,
            "transactionTypeId": "Renewal",
            "currencyId":"",
            "amountInvoiced": "675 $GSD",
            "discountId":"None",
            "licenseId": "HAP - Hourly Analysis Program",
            "transactionDate": "July 17th, 2025",
            "Quantity":"",
            "calculatedPrice":""
          },
            {
              "transactionId": 2,
            "transactionTypeId": "Renewal",
            "currencyId":"",
            "amountInvoiced": "675 $GSD",
            "discountId":"None",
            "licenseId": "HAP - Hourly Analysis Program",
            "transactionDate": "July 17th, 2025",
            "Quantity":"",
            "calculatedPrice":""
              },
              {
               "transactionId": 3,
            "transactionTypeId": "Renewal",
            "currencyId":"",
            "amountInvoiced": "675 $GSD",
            "discountId":"None",
            "licenseId": "HAP - Engineering Economics",
            "transactionDate": "May 17th, 2024",
            "Quantity":"",
            "calculatedPrice":"" 
                },
                {
                  "transactionId": 4,
            "transactionTypeId": "Renewal",
            "currencyId":"",
            "amountInvoiced": "225 $GSD",
            "discountId":"None",
            "licenseId": "HAP5 - Legacy HAP",
            "transactionDate": "Dec 17th, 2025",
            "Quantity":"", 
            "calculatedPrice":""
                  }
      ]
          dispatch({
              type: actionTypes.GET_C_TRANSACTION_SUCCESS,
              payload: data
          })
        }catch(error){
          dispatch({
            type: actionTypes.GET_C_TRANSACTION_FAILURE,
            payload: error
        })      
        } */
  await getTransactionByCustomerService(customerId)
    .then((response) => {      
      const data = response.data
      
      dispatch({
        type:actionTypes.GET_C_TRANSACTION_SUCCESS,
        payload:data
      });
    })
    .catch((error) =>{
      dispatch({
        type:actionTypes.GET_C_TRANSACTION_FAILURE,
        payload:error
      })
    })


  }
}

const generateNewLicenseAction = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.CREATE_NEW_GENERATELICENSE_START,
    });    
    window.startLoading();    
    await generateNewLicenseService(requestPayload)
      .then((response) => {        
        const data = response.data;        
        dispatch({
          type: actionTypes.CREATE_NEW_GENERATELICENSE_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {        
        dispatch({
          type: actionTypes.CREATE_NEW_GENERATELICENSE_FAILURE,
          payload: error,
        });
      }).finally(()=>{
        window.stopLoading();
      });
  };
};

const createNewLicenseAction = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.GET_CREATE_LICENSEKEY,
    });    
    await createNewLicenseService(requestPayload)
      .then((response) => {        
        const data = response.data;
        
        dispatch({
          type: actionTypes.GET_CREATE_LICENSEKEY_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.GET_CREATE_LICENSEKEY_FAILURE,
          payload: error,
        });
      });
  };
};

const renewalLicenseAction = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      payload: requestPayload,
      type: actionTypes.RENEWAL_LICENSE_START,
    });    
    window.startLoading();    
    await renewalLicenseService(requestPayload)
      .then((response) => {        
        const data = response.data;        
        dispatch({
          type: actionTypes.RENEWAL_LICENSE_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {        
        dispatch({
          type: actionTypes.RENEWAL_LICENSE_FAILURE,
          payload: error,
        });
      }).finally(()=>{
        window.stopLoading();
      });
  };
};


const updateQuantityAction = (requestPayload,params) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_QUANTITY_START,
    });        
    await updateQuantityService(requestPayload,params)
      .then((response) => {        
        console.log("COEMS");
        console.log("RESPONSE",response);
        const data = response.data;
        
        dispatch({
          type: actionTypes.UPDATE_QUANTITY_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {        
        dispatch({
          type: actionTypes.UPDATE_QUANTITY_FAILURE,
          payload: error?.response?.data,
        })
      });

  };
};
const getToolsOffered = (sales) => {
    return async(dispatch) => {
        dispatch({
            type: actionTypes.GET_TOOLS_OFFERED
        })
        window.startLoading();
        getToolsOfferedService(sales)
        .then((response)=>{
          const data = response.data;
            dispatch({
                type: actionTypes.GET_TOOLS_OFFERED_SUCCESS,
                payload: data
            })
        })
        .catch((error)=>{
          dispatch({
            type: actionTypes.GET_TOOLS_OFFERED_FAILURE,
            payload: error
        })
        }).finally(()=>{
          window.stopLoading();
        })
    }
}

const deleteCustomerContactAction = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.DELETE_CUSTOMERCONTACT_START
    });
    await deleteCustomerContactService(requestPayload)
    .then((response) => {
      const data = response.data;
      dispatch({
        type:actionTypes.DELETE_CUSTOMERCONTACT_SUCCESS,
        payload:data
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.DELETE_CUSTOMERCONTACT_FAILURE,
        payload: error
      })
    })
  }
}

const updateCustomerContactAction = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type:actionTypes.UPDATE_CUSTOMER_CONTACT
    });
    await updateCustomerContactService(requestPayload)
    .then((response) => {
      const data = response.data;
      dispatch({
        type:actionTypes.UPDATE_CUSTOMER_CONTACT_SUCCESS,
        payload:data
      });
    })
    .catch((error) => {
      dispatch({
        type:actionTypes.UPDATE_CUSTOMER_CONTACT_FAILURE,
        payload:error
      })
    })
  }
}

export {getSalesOfficeBasedMarketsList,getSelectedMarketsData,getExpirationDatesList,getSelectedExpirationDatesData,getStatusList,getSelectedStatusData,getCustomersList,getRenderCustomersListData,getCompanyTypeList,createNewCustomer,updateCustomerAction,deleteCustomerAction,getLicenseByCustomer,getTransactionByCustomer,getTools,getTransactionTypesList,getDiscountsList,generateNewLicenseAction,createNewLicenseAction,getToolsOffered,updateQuantityAction,renewalLicenseAction,getContactsByCustomer,createNewContactByCustomer,deleteCustomerContactAction,updateCustomerContactAction};